import { render, staticRenderFns } from "./Single-Contract-Detail.vue?vue&type=template&id=66f470e4&scoped=true"
import script from "./Single-Contract-Detail.vue?vue&type=script&lang=js"
export * from "./Single-Contract-Detail.vue?vue&type=script&lang=js"
import style0 from "./Single-Contract-Detail.vue?vue&type=style&index=0&id=66f470e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66f470e4",
  null
  
)

export default component.exports